// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Common Client V2 imports
const ImageUrlSizes = require('client-v2/common/records/image-url-sizes')
const { keyedReviver } = require('client-v2/common/state/record-reviver')
const {
  MIX_TYPE_USER_MIX,
  VISIBILITY_PUBLIC,
  VISIBILITY_PRIVATE
} = require('client-v2/common/models/collection/record')
// Sibling imports
const { COLLECTION_UPDATE_PENDING } = require('../actions')

class CollectionListItemRecord extends Immutable.Record({
  'cover_image_url': String(),
  'cover_image_urls': null,
  'created_at': String(), // Date-Time as a String
  description: String(),
  'follower_count': Number(),
  id: Number(),
  isMixed: Boolean(),
  'mix_type': String(MIX_TYPE_USER_MIX),
  'modified_at': String(), // Date-Time as a String
  name: String(),
  'posts_count': Number(),
  recommended: Boolean(),
  slug: String(),
  type: String(modelTypes.MIX),
  username: String(), // Needed for generating linkage
  visibility: String(VISIBILITY_PUBLIC)
}) {
  // No methods
}

CollectionListItemRecord.reviver = keyedReviver(CollectionListItemRecord, {
  'cover_image_urls': ImageUrlSizes.reviver
})

CollectionListItemRecord.propTypes = {
  'cover_image_url': PropTypes.string,
  'cover_image_urls': PropTypes.shape(ImageUrlSizes.propTypes),
  'created_at': PropTypes.string,
  description: PropTypes.string,
  'follower_count': PropTypes.number,
  id: PropTypes.number,
  isMixed: PropTypes.oneOf([
    true,
    false,
    COLLECTION_UPDATE_PENDING
  ]),
  'mix_type': PropTypes.string,
  'modified_at': PropTypes.string,
  name: PropTypes.string,
  'posts_count': PropTypes.number,
  recommended: PropTypes.bool,
  slug: PropTypes.string,
  type: PropTypes.string,
  username: PropTypes.string,
  visibility: PropTypes.oneOf([VISIBILITY_PRIVATE, VISIBILITY_PUBLIC])
}

module.exports = CollectionListItemRecord
